import config from '../config';
import React from 'react';
import NavDrawer from '../components/navdrawer';
import SEO from '../components/seo';
import '../stylesheets/main.css';
import '../stylesheets/speaker.css';
import { shapes } from '.';

export default () => {
  const organizers = config.content.organizers;
  return (
    <>
      <SEO title='Devfest' />
      <NavDrawer>
        <main>
          <section>
            <>
              <h3 className={'center'}>The Team</h3>
              <br />
              <div className={'speaker-grid'}>
                {organizers.map((organizer, index) => (
                  <div className={'speaker-container-landscape'} key={index}>
                    <div className={'shape'}>{shapes[index % shapes.length]}</div>
                    <div className={'dp-container'}>
                      <img alt={organizer.name} className={'speaker-dp'} src={organizer.dp} />
                    </div>
                    <div className={'speaker-info'}>
                      <h3>{organizer.name}</h3>
                      <h4>{organizer.designation}</h4>
                      <div className={'social-platter'}>
                        {organizer.twitter && (
                          <div>
                            <a href={organizer.twitter} target={'_blank'}>
                              <i className='fab fa-twitter green' />
                            </a>
                          </div>
                        )}
                        {organizer.linkedin && (
                          <div>
                            <a href={organizer.linkedin} target={'_blank'}>
                              <i className='fab fa-linkedin green' />
                            </a>
                          </div>
                        )}
                      </div>
                      <p className={'speaker-desc'}>{organizer.desc}</p>
                    </div>
                  </div>
                ))}
                <br />
                <br />
              </div>
            </>
          </section>
        </main>
      </NavDrawer>
    </>
  );
};
